import axios from 'axios';
import Vue from 'vue';
import {
    EventBus
} from './EventBus';
//import StateList from './StateList';
export default class DataManager {
    constructor() {
        this._vue = new Vue();
        this.stateAbrv = this._vue.$mainConfig.state.abbrev;
        this.stateFullName = this._vue.$mainConfig.state["display-name"];
        this.districtDataStore = {};
        this.congressLegislatorsData = null;
    }

    //This Gets ALL data for a given proposal (or new)
    getPerDistrictData(_proposalId) {
        // const columns = 'geoid,namelsad,districtid';
        const columns = 'geoid,osid,namelsad,districtid,stusps,statename,mapnotes,totpop20,tothisp20,totwhitenh20,totblacknh20,totaiannh20,totasiannh20,totnathawpinh20,totothernh20,tottwoplusnh20,vaptotal20,vaphisp20,vapwhitenh20,vapblacknh20,vapaiannh20,vapasiannh20,vapnathawpinh20,vapothernh20,vaptwoplusnh20,totpop_group_quarters20,adult_corr_facilites20,juvenile_corr_facilities20,compactrank,deviationnum,deviationpct,countysplitcount,townsplitcount,placesplitcount,votesbiden,votestrump,votesharebiden,votesharetrump,votesharris2024,votestrump2024,voteshareharris2024,votesharetrump2024';
        const api = this._vue.$mainConfig.api.hosts.api;
        const url = `${api}query/${_proposalId}?columns=${columns}&limit=0`;
        return axios.get(url);
    }

    //This gets data for one single district
    getSelectedDistrictData(_proposalId, geoid){
        const columns = 'geoid,osid,namelsad,districtid,stusps,statename,mapnotes,totpop20,tothisp20,totwhitenh20,totblacknh20,totaiannh20,totasiannh20,totnathawpinh20,totothernh20,tottwoplusnh20,vaptotal20,vaphisp20,vapwhitenh20,vapblacknh20,vapaiannh20,vapasiannh20,vapnathawpinh20,vapothernh20,vaptwoplusnh20,totpop_group_quarters20,adult_corr_facilites20,juvenile_corr_facilities20,compactrank,deviationnum,deviationpct,countysplitcount,townsplitcount,placesplitcount,votesbiden,votestrump,votesharebiden,votesharetrump,votesharris2024,votestrump2024,voteshareharris2024,votesharetrump2024';
        const api = this._vue.$mainConfig.api.hosts.api;
        const url = `${api}query/${_proposalId}?columns=${columns}&filter=geoid='${geoid}'&limit=0`;
        return axios.get(url);
    }

    getPerProposalData(_proposalId) {
        return this._vue.$pgConfig.find(p => _proposalId.includes(p.tablename))
    }

    getDistrictFromLatLng(_proposalId, _lat, _lng) {
        const api = this._vue.$mainConfig.api.hosts.api;
        const url = `${api}intersect_point/"${_proposalId}"/${_lng},${_lat},4326?geom_column=geom&columns=geoid&distance=0`;
        return axios.get(url);
    }

    //https://www.urbanresearchmaps.org/MA-Redistrict-API/v1/query/house_plan_ddc_20210928_all?columns=namelsad&limit=0
    getDistrictNameList(_tableName, _stateAbbrev){
        if(!_tableName.length || _tableName.length < 1) return {};
        const api = this._vue.$mainConfig.api.hosts.api;
        const url = `${api}query/"${_tableName}"?columns=namelsad,geoid,stusps&limit=0&filter=statefips='${_stateAbbrev}'`;
        //console.log(url)
        return axios.get(url);
    }

    //https://www.urbanresearchmaps.org/MA-Redistrict-API/v1/centroid/house_plan_ddc_20210928_all?geom_column=geom&srid=4326&filter=geoid%3D'25001'&force_on_surface=true
    getCentroidForGeoid(_proposalId, _geoid){
        const api = this._vue.$mainConfig.api.hosts.api;
        const url = `${api}centroid/"${_proposalId}"?geom_column=geom&srid=4326&filter=geoid%3D'${_geoid}'&force_on_surface=true`;
        return axios.get(url);
    }

    getCentroidForState(stateAbbrev){
        console.log(stateAbbrev);
       // return new Promise()
    }

    getLitigationStatus(_statefips, _jurisdiction){
        //https://dev.urbanresearchmaps.org/US-Redistrict-API/v1/query/litigationstatus?columns=*&filter=statefips%3D'37'&limit=0
        const api = this._vue.$mainConfig.api.hosts.api;
        const url = `${api}query/litigationstatus?columns=*&filter=statefips='${_statefips}' AND jurisdiction='${_jurisdiction}'&limit=0`;
        return axios.get(url);
    }

    getNewBBoxView(proposalA, geoidA, proposalB, geoidB) {
        const api = this._vue.$mainConfig.api.hosts.api;

        const urlA = `${api}bbox/${proposalA}?geom_column=geom&srid=4326&filter=districtid='${geoidA}'%20OR%20geoid='${geoidA}%27`
        const urlB = `${api}bbox/${proposalB}?geom_column=geom&srid=4326&filter=districtid='${geoidB}'%20OR%20geoid='${geoidB}%27`
        
        let bboxRequests = [];
        if(proposalA && geoidA) bboxRequests.push(axios.get(urlA));
        if(proposalB && geoidB) bboxRequests.push(axios.get(urlB));
        return bboxRequests;
    }


    GetColor(val, scale, belowThreshold = false) {
        //TODO: If pop is less than threshold then return clear
        if (belowThreshold) return 'rgba(0,0,0,0)';

        for (let s = 0; s < scale.length; s++) {
            if (scale[s].step.length === 2) {
                if (s === 0) {
                    if (
                        (scale[s].step[1] === false && +val < +scale[s].step[0]) || (scale[s].step[1] === true && +val <= +scale[s].step[0])) {
                        return scale[s].color;
                    }

                } else {
                    if (
                        (scale[s].step[1] === false && +val > +scale[s].step[0]) || (scale[s].step[1] === true && +val >= +scale[s].step[0])) {
                        return scale[s].color;
                    }
                }

            } else if (this.isBetween(val, scale[s].step)) {
                return scale[s].color;
            }
        }

        return 'rgba(0,0,0,0)'
    }

    isBetween(_val, step) {
        const a = step[0];
        const b = step[2];
        const minInclusive = step[1];
        const maxInclusive = step[3];

        var min = Math.min.apply(Math, [a, b]),
            max = Math.max.apply(Math, [a, b]);

        const aReq = minInclusive ? _val >= min : _val > min;
        const bReq = maxInclusive ? _val <= max : _val < max;

        return (aReq && bReq);
    }
    
    getNewDataForDistricts(_districtOpts) {
        let requests = []
        _districtOpts.forEach((distOp) => {
            requests.push(this.getDistrictFromLatLng(distOp._id, distOp.lnglat[1], distOp.lnglat[0]));
        })

        Promise.all(requests).then((responses) => {

            const mappedResponses = responses.map((d, i) => {
                return {
                    geoid: d.data[0].geoid,
                    propid: _districtOpts[i]._id,
                    side: _districtOpts[i]._side
                }
            });
            mappedResponses.forEach((mappedResp) => {
                EventBus.$emit(`update-side-panel-${mappedResp.side}`, mappedResp);
            })

        })
    }

    districtNumFromFips(_districtFIPS) {

        return +_districtFIPS
            .toString()
            .substring(2, _districtFIPS.length)
            .toString();

    }

    async getCongressLegislatorsData(state, id){
        if(!this.congressLegislatorsData){
            this.congressLegislatorsData = await axios.get(this._vue.$mainConfig.api.hosts.congressLegislators).then(res => {
                return res?.data ?? []
            })
        }

        const leg = this.congressLegislatorsData.find(d => d.terms.at(-1).district === id && d.terms.at(-1).state === state.toUpperCase())
        // {
        //     "id":,
        //     "name": {
        //         "first": "Nicole",
        //         "last": "Malliotakis",
        //         "official_full": "Nicole Malliotakis"
        //     },
        //     "bio": 
        //     "terms": [
        //         {
        //             "type": "rep",
        //             "start": "2025-01-03",
        //             "end": "2027-01-03",
        //             "state": "NY",
        //             "district": 11,
        //             "party": "Republican",
        //             "url": "https://malliotakis.house.gov",
        //             "address": "1124 Longworth House Office Building Washington DC 20515-3211",
        //             "office": "1124 Longworth House Office Building",
        //             "phone": "202-225-3371"
        //         }
        //     ]
        // }
        // match the openstate format
        const legCleaned = leg ? {
            name: leg.name.official_full, party: leg.terms.at(-1).party
        } : null

        return new Promise((resolve, reject) => {
            if(leg){
                resolve(legCleaned)
            }
            reject(`Can not find entry for ${state}:${id}`)
        })
    }


    getOpenStatesURL(_state = this.stateFullName, district, chamber) {
       // return encodeURI(`${this._vue.$mainConfig.api.hosts.openstates}?jurisdiction=${_state}&org_classification=${chamber}&district=${district}&page=1&per_page=10&apikey=${this._vue.$mainConfig.api.keys.openStates}`)
       return encodeURI(`${this._vue.$mainConfig.api.hosts.openstates}?jurisdiction=${_state}&org_classification=${chamber}&district=${district}&page=1&per_page=10&apikey=${this._vue.$mainConfig.api.keys.openStates}`)
    }


    getRepData(state, _id, type) {
        if (type === 'cd') {
            return this.getCongressLegislatorsData(state, parseInt(_id))
        } else {
            const chamber = type === 'ad' ? 'lower' : 'upper';
            const openStatesUrl = this.getOpenStatesURL(state, parseInt(_id), chamber);
            return axios.get(openStatesUrl).then(res => res.data.results[0])
        }
    }


    //   const pp_json = await pp_response.json();
}
